/**
 * VideoCTA JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class VideoCTA
 */
class VideoCTA {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.videoCta       = $( '.video-cta' );
        this.videoBanner    = $( '.video-cta__banner' );
        this.videoImage     = $( '.video-cta__image-container' );
        this.videoCtaLink   = $( '.video-cta__banner__text__link' );
        this.videoContainer = $( '.video-cta__video-container' );
    }

    /**
     * This function is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Bind events
     */
    events() {

        this.videoCtaLink.on( 'click', ( e ) => {

            e.preventDefault();
            this.openVideo();
        });
    }

    /**
     * Opens the video
     */
    openVideo() {

        this.videoCta.addClass( 'video-cta__video-visible' );
        this.videoImage.hide();
        this.videoBanner.hide();
        this.videoContainer.removeClass( 'u-hide' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        if ( ! $( '.video-cta' ).length ) {

            return;

        }

        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = VideoCTA;



// WEBPACK FOOTER //
// ./assets/scripts/videocta.js